export enum EMediaType {
  /** Планировка **/
  Layout = 'layout',
  /** Фото **/
  Photo = 'photo',
  /** 3D-тур **/
  Tour = 'tour',
}

export interface IGallerySlide {
  type: EMediaType;
  full: string;
  img: string;
  thumb: string;
}

export interface ICoords {
  x: number;
  y: number;
}

export interface IFullscreenSlideProps {
  type: EMediaType;
  src: string;
  zoomProps?: IZoomProps;
  dataName?: string;
  onClick?(): void;
}

export interface IZoomProps {
  zoomEnabled: boolean;
  zoomStyle: React.CSSProperties;
  onTouchStart(e: React.TouchEvent<HTMLElement>): void;
  onTouchMove(e: React.TouchEvent<HTMLElement>): void;
  onTouchEnd(e: React.TouchEvent<HTMLElement>): void;
}
